// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `p-dropdown.ng-dirty.ng-invalid>.p-dropdown {
    border-color:black !important;
}

:host ::ng-deep .p-dropdown-items {
    padding: 0;
}
`, "",{"version":3,"sources":["webpack://./src/app/features/selectregion/selectregion.component.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;AACjC;;AAEA;IACI,UAAU;AACd","sourcesContent":["p-dropdown.ng-dirty.ng-invalid>.p-dropdown {\r\n    border-color:black !important;\r\n}\r\n\r\n:host ::ng-deep .p-dropdown-items {\r\n    padding: 0;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
